import { Box, IconButton } from "@mui/material";
import { ParagraphText, UBInput } from "../../../../../Libraries";
import UBDateSelect from "../../../../../Libraries/UBDateSelect";
import { ArrowUpDownIcon } from "../../../../../assets/icons/icon";
import { memo, useEffect, useRef } from "react";
import {
  removeLeadingZeros,
  removeRsFromValue,
  validatePriceQtyInput,
} from "../../../../../utils";
import styles from "./ItemRow.module.css";
import { sentenceCase } from "../../../../../constants";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";

const ItemRow = memo(
  ({
    className,
    dataItem,
    fieldStates,
    rowIndex,
    handleFieldChange,
    handleUnitToggle,
    isSingleStock,
    gridTemplateColumns,
  }) => {
    const inputRef = useRef();
    const stock_units = fieldStates[rowIndex]?.stock_units || {
      unit: "",
      secondary_unit: "",
      selected_unit: "",
    };
    const stock_quantity = fieldStates[rowIndex]?.stock_quantity || "";
    const has_secondary = fieldStates[rowIndex]?.has_secondary;

    useEffect(() => {
      if (isSingleStock) {
        inputRef.current.focus();
      }
    }, [isSingleStock]);

    const StockUnitSuffix = ({ stock_units, has_secondary, rowIndex }) => (
      <Box className={styles.unitSuffix} onClick={(e) => e.stopPropagation()}>
        <ParagraphText
          onClick={(e) => {
            e.stopPropagation();
            if (has_secondary) {
              handleUnitToggle(rowIndex);
            }
          }}
          className={`${styles.unitLabel} ${has_secondary ? styles.unitLabelWithToggle : ""}`}
        >
          {stock_units.selected_unit}
        </ParagraphText>

        {has_secondary && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              if (has_secondary) {
                handleUnitToggle(rowIndex);
              }
            }}
            id="unit_toogle"
            size="small"
            className={styles.unitToggleBtn}
          >
            <ArrowUpDownIcon />
          </IconButton>
        )}
      </Box>
    );

    return (
      <Box
        className={`stockInOutModalTableRow ${className} ${styles.modalTableRow}`}
        key={rowIndex}
        sx={{ gridTemplateColumns }}
        onClick={() =>
          triggerLogEvent(analytics, "sb_io_item_click", {
            item_id: dataItem?.id,
            item_name: dataItem?.name,
            row_index: rowIndex,
          })
        }
      >
        <Box className={`NameBox ${className} ${styles.modalTableRowColumn}`}>
          <ParagraphText className={"fontSize14 newFontColor truncateOneLine"}>
            {sentenceCase(dataItem?.name || "")}
          </ParagraphText>
        </Box>

        <Box className={`${className} ${styles.modalTableRowColumn}`}>
          <ParagraphText className={"fontSize12"}>
            {dataItem.stock !== undefined
              ? Math.floor(dataItem.stock * 100) / 100 || 0
              : "--"}
          </ParagraphText>
        </Box>

        <Box className={`${className} ${styles.modalTableRowColumn}`}>
          <UBInput
            inputId={"price"}
            placeholder="Rs. "
            value={
              fieldStates[rowIndex]?.price
                ? `Rs. ${fieldStates[rowIndex]?.price}`
                : ""
            }
            onChange={(e, value) => {
              if (validatePriceQtyInput(value, 9999999)) {
                const result = removeLeadingZeros(removeRsFromValue(value));
                handleFieldChange(rowIndex, "price", result);
              }
            }}
          />
        </Box>

        <Box className={`${className} ${styles.modalTableRowColumn}`}>
          <UBInput
            inputId={"stock_quantity"}
            maxLength={7}
            inputRef={inputRef}
            value={stock_quantity}
            onChange={(e, inputValue) => {
              if (/^\d*$/.test(inputValue)) {
                handleFieldChange(
                  rowIndex,
                  "stock_quantity",
                  removeLeadingZeros(inputValue),
                );
              }
            }}
            disabled={false}
            placeholder="0"
            suffix={
              <StockUnitSuffix
                stock_units={stock_units}
                has_secondary={has_secondary}
                rowIndex={rowIndex}
              />
            }
          />
        </Box>

        <Box className={`${className} ${styles.modalTableRowColumn}`}>
          <Box className={styles.inOutModalDateBoxWrapper}>
            <UBDateSelect
              id={`stock_in_out_date_${rowIndex}`}
              selectedDate={fieldStates[rowIndex]?.transacted_at}
              setSelectedDate={(date) => {
                handleFieldChange(rowIndex, "transacted_at", date);
              }}
              title={null}
              placeholder={"Select date"}
              isCalendericon
              isRequired
            />
          </Box>
        </Box>
      </Box>
    );
  },
);

export default ItemRow;
